import { Button } from '@mui/material';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';


const Banner = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="d-flex flex-column justify-content-center align-items-center text-center"
            style={{
                backgroundImage: 'url(banner-background.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100%',
                minHeight: '100vh',
                padding: '2rem',
                position: 'relative',
            }}
        >
            {/* Logo in Top-Left */}
            <motion.div
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
                style={{ position: 'absolute', top: '1.5rem', left: '2rem' }}
            >
                <img src="logo.png" alt="Logo" style={{ width: '200px' }} />
            </motion.div>

            {/* Main Content */}
            <div className="container" style={{ maxWidth: '720px' }}>
                <motion.h1
                    className="fw-bold mb-3"
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.5 }}
                >
                    Transcribe Audio to Text in Seconds.
                    <br />
                    Accurate, Fast, and AI–Powered!
                </motion.h1>

                <motion.p
                    className="lead text-muted mb-4"
                    initial={{ y: 30, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 1 }}
                >
                    Upload your audio, and let our AI do the work. Get high-quality transcriptions with speaker recognition, summaries, and insights.
                </motion.p>

                <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 2 }}
                >
                    <a href="#free-trial-section" style={{ textDecoration: 'none' }}>
                        <Button className="px-4" style={{ backgroundColor: '#e53935', color: '#fff' }}>
                            Try for Free
                        </Button>
                    </a>
                </motion.div>
            </div>
        </motion.div>
    );
};
export default Banner